import React, { useEffect, useMemo } from 'react'
import { connect } from 'react-redux'
import {
  CustomModal,
  InputText,
  InputTime,
  CustomCalendar,
  CustomDropdown,
  CustomInputTextArea,
  InputPlacaVeiculo,
  Btn,
} from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useUtilizacaoModal, { LOAD_MESSAGE } from './UtilizacaoModalHook'

const pickValue = e =>
  e && Object.prototype.hasOwnProperty.call(e, 'value')
    ? e.value
    : e && e.target
      ? e.target.value
      : e

function UtilizacaoModal({ show, data, onModalClose, onModalSave, selectedTp, tomadas, dispatch }) {
  const { state, localDispatch } = useUtilizacaoModal()

  useEffect(() => {
    if (show) localDispatch.start(data, selectedTp, tomadas)
  }, [show, data, selectedTp, tomadas])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break
      case LOAD_MESSAGE.SAVE:
        dispatch(showLoadingBox('Salvando utilização', 'Aguarde...'))
        localDispatch
          .save(selectedTp)
          .then(saved => {
            dispatch(showMessageBox('Utilização salva com sucesso.', null))
            onModalSave(saved)
            onModalClose()
          })
          .catch(err =>
            dispatch(showMessageBox(null, err && err.message ? err.message : String(err))),
          )
          .finally(() => dispatch(hideLoadingBox()))
        break
      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) dispatch(showMessageBox(null, state.errorMessage))
  }, [state.errorMessage])

  const { utl } = state

  const selectedTomadaOption = useMemo(() => {
    if (!Array.isArray(tomadas)) return null
    const id = Number(utl.patio_tomada_id)
    return tomadas.find(b => Number(b.id) === id) || null
  }, [tomadas, utl.patio_tomada_id])

  const selectedCompanyOption = useMemo(
    () => (state.companies || []).find(c => c.id === (utl.company_id || null)) || null,
    [state.companies, utl.company_id],
  )

  return (
    <CustomModal
      header={utl.id ? 'Editar Utilização de Tomada' : 'Nova Utilização de Tomada'}
      isVisible={show}
      onClose={() => {
        onModalClose()
        localDispatch.reset()
      }}
      width="900px"
    >
      <div key={state.instanceKey} className="p-grid">
        <div className="p-col-6">
          <CustomDropdown
            label="Tomada*"
            optionLabel="numero_referencia"
            options={tomadas}
            value={selectedTomadaOption}
            onChange={opt => {
              localDispatch.onChange('patio_tomada_id', opt ? Number(opt.id) : null)
            }}
            placeholder="Selecione a tomada"
            filter
          />
        </div>
        <div className="p-col-6">
          <CustomDropdown
            marginTop={10}
            label="Empresa*"
            optionLabel="name"
            options={state.companies}
            value={selectedCompanyOption}
            onChange={opt => localDispatch.onChange('company_id', opt ? Number(opt.id) : null)}
            placeholder="Selecione a empresa"
            filter
          />
        </div>

        <div className="p-col-6">
          <CustomCalendar
            marginTop={10}
            label="Data Inicial*"
            value={utl._dataInicial}
            onChange={e => localDispatch.onChange('_dataInicial', pickValue(e))}
          />
        </div>
        <div className="p-col-6">
          <InputTime
            marginTop={10}
            label="Hora Inicial*"
            value={utl._horaInicial || ''}
            onChange={e => localDispatch.onChange('_horaInicial', pickValue(e))}
          />
        </div>

        <div className="p-col-6">
          <CustomCalendar
            marginTop={10}
            label="Data Final*"
            value={utl._dataFinal}
            onChange={e => localDispatch.onChange('_dataFinal', pickValue(e))}
          />
        </div>
        <div className="p-col-6">
          <InputTime
            marginTop={10}
            label="Hora Final*"
            value={utl._horaFinal || ''}
            onChange={e => localDispatch.onChange('_horaFinal', pickValue(e))}
          />
        </div>

        <div className="p-col-3">
          <InputPlacaVeiculo
            label="Placa*"
            value={utl.placa || ''}
            onChange={e => localDispatch.onChange('placa', pickValue(e))}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="Motorista*"
            value={utl.motorista}
            onChange={e => localDispatch.onChange('motorista', pickValue(e))}
          />
        </div>
        <div className="p-col-3">
          <InputText
            label="RG"
            value={utl.rg}
            onChange={e => localDispatch.onChange('rg', pickValue(e))}
          />
        </div>
        <div className="p-col-12">
          <CustomInputTextArea
            rows={5}
            label="Observação"
            value={utl.observacao}
            onChange={e => localDispatch.onChange('observacao', pickValue(e))}
          />
        </div>

        <div className="p-col-12 text-center" style={{ marginTop: 10 }}>
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(selectedTp)}>Salvar</Btn>
          <Btn
            onClick={() => {
              onModalClose()
              localDispatch.reset()
            }}
            style={{ marginLeft: 10 }}
          >
            Cancelar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(UtilizacaoModal)
